export const iconFontAwesomeAlphabetAddressCard = (
	<i className="fa-solid fa-address-card"></i>
);
